import { useMutation, useQuery } from "@tanstack/react-query";
import { adminFetch } from "./client";

export interface MfaStatus {
  mfa_required: boolean;
  masked_phone: string | null;
}

export interface OtpSendResponse {
  sent: boolean;
  masked_phone: string;
  expires_in_seconds: number;
}

export interface OtpVerifyResponse {
  verified: boolean;
  session_ttl_seconds: number;
}

export function useMyMfaStatus(enabled: boolean = true) {
  return useQuery({
    queryKey: ["auth", "my-mfa-status"],
    queryFn: () => adminFetch<MfaStatus>("/api/v1/auth/me/mfa-status"),
    enabled,
    staleTime: 0,
  });
}

export function useSendOtp() {
  return useMutation({
    mutationFn: () =>
      adminFetch<OtpSendResponse>("/api/v1/auth/otp/send", { method: "POST" }),
  });
}

export function useVerifyOtp() {
  return useMutation({
    mutationFn: (code: string) =>
      adminFetch<OtpVerifyResponse>("/api/v1/auth/otp/verify", {
        method: "POST",
        body: JSON.stringify({ code }),
      }),
  });
}

// One-shot fetcher used by the login flow before the user object is settled
// in the auth store. Returns null on error so callers can fall back safely.
export async function fetchMfaStatusOnce(): Promise<MfaStatus | null> {
  try {
    return await adminFetch<MfaStatus>("/api/v1/auth/me/mfa-status");
  } catch {
    return null;
  }
}
